import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-eqbd-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatDialogModule],
  templateUrl: './eqbd-confirmation-dialog.component.html',
  styleUrl: './eqbd-confirmation-dialog.component.scss'
})
export class EqbdConfirmationDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<EqbdConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string; confirmText?: string; cancelText?: string }
  ) {}

  onAmendQuote(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
